import React from "react";
import Work from "../components/Work/Work";

const WorkPage: React.FC = () => {
  return <Work />;
};

export default WorkPage;
